import React from 'react'
import './Grid.css'

export const Grid = props => (
    <div className={`Grid ${props.className || ''}`}>
        {props.children}
    </div>
)

export const GridCol = props => (
    <div className={`GridCol ${props.className || ''}`}>
        {props.children}
    </div>
)

export const Container = props => (
    <div className={`Container ${props.className || ''}`}>
        {props.children}
    </div>
)


// WEBPACK FOOTER //
// ./src/components/common/Grid.js